export default "__VITE_ASSET__SHrVwJ09__"